import { ReactNode } from "react";
import { useGlobalStore } from "@/stores/global-store";
import { EntitlementName } from "../types/permissions";

/* Prop Types */
interface EntitlementGateProps {
  entitlement: EntitlementName;
  children: ReactNode;
  fallback?: ReactNode;
  debugFlag?: boolean;
  debugFallback?: boolean;
}

/**
 * EntitlementGate
 * Component to conditionally render children based on entitlement
 * @param entitlement - The entitlement to check
 * @param children - The content to render if the entitlement is enabled
 * @param fallback - The content to render if the entitlement is disabled
 * @param debugFlag - If true, always render children (for testing purposes)
 * @param debugFallback - If true, always render fallback (for testing purposes)
 */
export const EntitlementGate = ({ entitlement, children, debugFlag, debugFallback, fallback = null }: EntitlementGateProps) => {
  /* Stores */
  const entitlements = useGlobalStore((state) => state.entitlements);

  /* Consts */
  const isEntitlementEnabled = entitlement ? entitlements?.some((item) => item.name === entitlement) : false;

  /* Return */
  if (debugFlag) return <>{children}</>;
  if (debugFallback) return <>{fallback}</>;
  return <>{isEntitlementEnabled ? children : fallback}</>;
};
